// src/hooks/useFormatosProfesor.ts
import { useState, useEffect } from "react";
import api from "../api/axios";

export interface Formato {
  id: number;
  nombreFormato: string;
}

export function useFormatosProfesor(idProfesor: number) {
  const [rows, setRows] = useState<Formato[]>([]);
  const [loading, setL] = useState(false);

  useEffect(() => {
    if (!idProfesor) {
      setRows([]);
      return;
    }

    setL(true);
    api
      .get(`/profesores/${idProfesor}/formatos`)
      .then((r) => {
        /* → [{ idFormato, formato:{ id, nombreFormato,… } }, …] */
        const list = r.data.map((f: any) => ({
          id: f.formato.id,
          nombre: f.formato.nombreFormato, // para la UI
          nombreFormato: f.formato.nombreFormato,
        }));
        setRows(list);
      })
      .finally(() => setL(false));
  }, [idProfesor]);

  return { rows, loading };
}
